<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="/" class="footer-link">GB Wave</a> — Independent guides and news about GB WhatsApp. All trademarks belong to their owners.</p>
    </div>
    <div class="footer-links">
      <router-link to="/about-us/" class="footer-link">About</router-link>
      <router-link to="/contact-us/" class="footer-link">Contact</router-link>
      <router-link to="/privacy-policy/" class="footer-link">Privacy</router-link>
      <router-link to="/terms-of-use/" class="footer-link">Terms</router-link>
      <router-link to="/disclaimer/" class="footer-link">Disclaimer</router-link>
      <router-link to="/dmca/" class="footer-link">DMCA</router-link>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(180deg, #f7fcf8 0%, #ffffff 55%);
  color: #243041;
  padding: 22px 0;
  border-top: 1px solid rgba(40, 167, 69, 0.12);
}

@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

/* 上下结构：版权在上，链接在下 */
.footer-container {
  width: 92%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  overflow-x: clip;
  box-sizing: border-box;
}

.footer-note {
  font-size: 14px;
  max-width: none;
  width: 100%;
  color: #243041;

  p {
    margin: 0;
    line-height: 1.5;
    white-space: nowrap;
  }
}

/* 窄屏仍允许换行，避免横向溢出 */
@media (max-width: 900px) {
  .footer-note p {
    white-space: normal;
  }
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0;
  font-size: 0.8rem;
  line-height: 1.4;
}

/* 竖线分隔：About | Contact | Privacy ... */
.footer-links .footer-link + .footer-link::before {
  content: '|';
  display: inline-block;
  margin: 0 0.45em;
  color: rgba(31, 107, 58, 0.35);
  font-weight: 400;
  pointer-events: none;
}

.footer-link {
  color: #1f6b3a;
  text-decoration: none;
  font-size: inherit;
  font-weight: 600;
  text-underline-offset: 2px;
  transition: color 0.18s ease, text-decoration-color 0.18s ease;
}

.footer-link:hover,
.footer-link:focus-visible {
  color: var(--gb-wave-green, #28a745);
  text-decoration: underline;
  text-decoration-color: var(--gb-wave-green, #28a745);
}

@media (max-width: 768px) {
  .footer-note {
    font-size: 12px;
  }

  .footer-links {
    font-size: 0.72rem;
  }
}
</style>

